var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{class:_vm.stackClass,attrs:{"data-cy":"KCTLoadingIndicator"}},[_c('FontAwesomeIcon',{staticClass:"fa-spin loader",attrs:{"icon":"spinner","size":"2x"}}),_c('span',{attrs:{"data-cy":"loadingText"}},[_vm._t("loading-text")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }